/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
// material
import Space from 'material/space/space';
import ConfigV2Controller from 'material/expandablesection/v2/configv2controller/configv2controller'
import ExpandableSection from 'material/expandablesection/expandablesection'
import { ReactComponent as Key } from 'assets/icons/key.svg'
import ProductCard from './productcard/productcard';
// content
// styles
import injectSheet from 'react-jss'
import styles from './productaccess_styles'


/* ========== ~~~~~~~~~~ MODERATION CONFIG V2: GENERAL SECTION ~~~~~~~~~~ ========== */
const ProductAccess = injectSheet(styles)((props) => {
  const [isOpened, setIsOpened] = useState(false)

  const handleToggle = () => setIsOpened(!isOpened)

  const controller = (
    <ConfigV2Controller
      isOpened={isOpened}
      hideDefaultActionButtons={true}
      handleToggle={handleToggle}
      icon={<Key />}
      title='Product Access'
    />
  );

  return (
    <ExpandableSection
      className={`expandablesectionv2 productaccess ${props.classes.productaccess}`}
      controller={controller}
      isOpened={isOpened}
      handleToggle={handleToggle}
    >
      <Space justifyContent={'center'} style={{ flexFlow: 'wrap'}} gap={24}>
        <ProductCard productType={'COMMENTING_V2'} />
        <ProductCard productType={'ARTICLE_SENTIMENT_V2'} />
        <ProductCard productType={'TRENDING_NOW_V2'} />
      </Space>
    </ExpandableSection>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ProductAccess;